import { AmbaDropdownItem, ServerStatus } from './globalModels';

export type Language = {
  url: string;
  name: string;
  code: string;
  flag_code: string;
};

export type AutoTranslateLanguage = {
  url: string;
  language_uid: Language;
  status: string;
  created_at: string;
};

export type PortalCampaign = {
  uid: number;
  name: string;
};

export type Customization = {
  assets_tab_text: string;
  auto_translate_languages: AutoTranslateLanguage[];
  button_color: string;
  button_text_color: string;
  campaigns_with_commission_label_access: any[];
  commissions_label: string | null;
  commissions_tab_text: string;
  created_by_email: string | null;
  dashboard_body_scripts: string;
  dashboard_head_scripts: string;
  dashboard_header: string | null;
  dashboard_tab_text: string;
  default_groups: string;
  default_language_uid: Language;
  favicon: string;
  form_city_checked: boolean;
  form_city_label: string;
  form_city_position: number;
  form_city_required: boolean;
  form_company_checked: boolean;
  form_company_label: string;
  form_company_position: number;
  form_company_required: boolean;
  form_country_checked: boolean;
  form_country_label: string;
  form_country_position: number;
  form_country_required: boolean;
  form_custom1_checked: boolean;
  form_custom1_label: string;
  form_custom1_position: number;
  form_custom1_required: boolean;
  form_custom10_checked: boolean;
  form_custom10_label: string;
  form_custom10_position: number;
  form_custom10_required: boolean;
  form_custom2_checked: boolean;
  form_custom2_label: string;
  form_custom2_position: number;
  form_custom2_required: boolean;
  form_custom3_checked: boolean;
  form_custom3_label: string;
  form_custom3_position: number;
  form_custom3_required: boolean;
  form_custom4_checked: boolean;
  form_custom4_label: string;
  form_custom4_position: number;
  form_custom4_required: boolean;
  form_custom5_checked: boolean;
  form_custom5_label: string;
  form_custom5_position: number;
  form_custom5_required: boolean;
  form_custom6_checked: boolean;
  form_custom6_label: string;
  form_custom6_position: number;
  form_custom6_required: boolean;
  form_custom7_checked: boolean;
  form_custom7_label: string;
  form_custom7_position: number;
  form_custom7_required: boolean;
  form_custom8_checked: boolean;
  form_custom8_label: string;
  form_custom8_position: number;
  form_custom8_required: boolean;
  form_custom9_checked: boolean;
  form_custom9_label: string;
  form_custom9_position: number;
  form_custom9_required: boolean;
  form_date_of_birth_checked: boolean;
  form_date_of_birth_label: string;
  form_date_of_birth_position: number;
  form_date_of_birth_required: boolean;
  form_email_checked: boolean;
  form_email_label: string;
  form_email_position: number;
  form_email_required: boolean;
  form_first_name_checked: boolean;
  form_first_name_label: string;
  form_first_name_position: number;
  form_first_name_required: boolean;
  form_groups_checked: boolean;
  form_groups_label: string;
  form_groups_position: number;
  form_groups_required: boolean;
  form_job_title_checked: boolean;
  form_job_title_label: string;
  form_job_title_position: number;
  form_job_title_required: boolean;
  form_last_name_checked: boolean;
  form_last_name_label: string;
  form_last_name_position: number;
  form_last_name_required: boolean;
  form_paypal_email_checked: boolean;
  form_paypal_email_label: string;
  form_paypal_email_position: number;
  form_paypal_email_required: boolean;
  form_phone_checked: boolean;
  form_phone_label: string;
  form_phone_position: number;
  form_phone_required: boolean;
  form_state_checked: boolean;
  form_state_label: string;
  form_state_position: number;
  form_state_required: boolean;
  form_street_checked: boolean;
  form_street_label: string;
  form_street_position: number;
  form_street_required: boolean;
  form_zip_checked: boolean;
  form_zip_label: string;
  form_zip_position: number;
  form_zip_required: boolean;
  head_description: string;
  head_title: string;
  link_color: string | null;
  login_body_scripts: string;
  login_head_scripts: string;
  login_page_logo: string;
  mobile_banner_image: string;
  payouts_tab_text: string;
  portal_auto_login: boolean;
  portal_campaign_obj: PortalCampaign;
  portal_campaign: number;
  portal_customizations: PortalCustomizations;
  registration_body_scripts: string;
  registration_head_scripts: string;
  registration_page_button_text: string;
  registration_page_form_header: string;
  registration_page_logo: string;
  registration_page_message: string;
  registration_page_redirect: boolean;
  registration_page_right_column: string;
  registration_page_type: string;
  rewards_tab_text: string | null;
  set_contact_loyalty_on_register: boolean;
  show_ads: boolean;
  show_awaiting_approval: boolean;
  show_awaiting_payment: boolean;
  show_clicks: boolean;
  show_commissions_campaign: boolean;
  show_commissions_commission: boolean;
  show_commissions_event1: boolean;
  show_commissions_event2: boolean;
  show_commissions_event3: boolean;
  show_commissions_graph: boolean;
  show_commissions_referred_by: boolean;
  show_commissions_revenue: boolean;
  show_commissions_transaction_id: boolean;
  show_conversions: boolean;
  show_customer_email: boolean;
  show_customer_name: boolean;
  show_earned: boolean;
  show_logout: boolean;
  show_paid_out_so_far: boolean;
  show_payouts_tab: boolean;
  show_profile: boolean;
  show_request_payout: boolean;
  show_revenue: boolean;
  show_stats_tab: boolean;
  show_referral_network_tab: boolean;
  show_zero_commissions: boolean;
  stats_tab_text: string;
  storefront_customizations: StorefrontCustomization;
  storefront_portal_logo: string;
  tabs: CustomTab[];
  terms_text: string;
  updated_by_email: string;
  url: string;
};

export type CustomTab = {
  campaigns_with_tab_access: number[];
  company_user_uid: number;
  created_at: string;
  customization_uid: number;
  enabled: boolean;
  groups: number[];
  icon: string;
  name: string;
  page_element: string | null; // assuming it can be either null or string
  slug: string;
  source: string;
  uid: number;
  updated_at: string;
};

export type CustomScriptsType = Pick<
  Customization,
  | 'dashboard_head_scripts'
  | 'dashboard_body_scripts'
  | 'login_head_scripts'
  | 'login_body_scripts'
  | 'registration_head_scripts'
  | 'registration_body_scripts'
>;

export type LoginCustomization = {
  login_page_logo: string; //https://ambassador-api.s3.amazonaws.com/uploads/portal/24940/2022_11_01_19_31_20_BLUESHARK-REBRAND-BLACK.png;
  login_body_scripts: string; //null
  login_head_scripts: string; //null
  button_color: string; //null
  button_text_color: string; //null
};

export type HeaderCustomization = {
  mobile_banner_image?: string;
  campaign_portal_logo?: string;
  login_page_logo?: string;
  storefront_portal_logo?: string;
};

export type SideBarCustomization = {
  tabs: []; //['page name'];
  show_stats_tab: boolean; //true
  show_payouts_tab: boolean; //true
  show_ads: boolean; //false
  show_share_link_tab?: boolean; //true
  show_dashboard: boolean; //true
  dashboard_tab_text: string; //null
  stats_tab_text: string; //null
  commissions_tab_text: string; //null
  payouts_tab_text: string; //null
  assets_tab_text: string; //null
  share_link_tab_text: string; //null
  rewards_tab_text: string;
};

export type DashboardCustomization = {
  login_page_logo: string; //https://ambassador-api.s3.amazonaws.com/uploads/portal/24940/2022_11_01_19_31_20_BLUESHARK-REBRAND-BLACK.png;
  login_body_scripts: string; //null
  login_head_scripts: string; //null
  button_color: string; //null
  button_text_color: string; //null
};

export type RegisterCustomization = {
  ambassador_state_choices: AmbaDropdownItem[]; //converted to dropdown item
  ambassador_state_type: string;
  background_color: string;
  button_color: string;
  button_text_color: string;
  form_state_label: string;
  groups: AmbaDropdownItem[]; //converted to dropdown item
  mobile_banner_image: string;
  portal_auto_login: boolean;
  recaptcha_enabled: boolean;
  registration_head_scripts?: string;
  registration_page_button_text: string;
  registration_page_form_header: string;
  registration_page_logo: string;
  registration_page_message: string;
  registration_page_redirect: boolean;
  registration_page_right_column: string;
  set_contact_loyalty_on_register: boolean;
  terms_text: string;
};

export type SelectedFormFields = {
  form_first_name_position: number; //1;
  form_first_name_required: boolean; //true
  form_first_name_checked: boolean; //true
  form_first_name_label: string; //null
  form_last_name_position: number; //number; //2;
  form_last_name_required: boolean; //true
  form_last_name_checked: boolean; //true
  form_last_name_label: string; //null
  form_email_checked: boolean;
  form_email_position: number; //number; //3;
  form_email_label: string; //null
  form_email_required: boolean; //null
  form_phone_position: number; //number; //4;
  form_phone_required: boolean; //false
  form_phone_checked: boolean; //false
  form_phone_label: string; //null
  form_paypal_email_position: number; //number; //5;
  form_paypal_email_required: boolean; //false
  form_paypal_email_checked: boolean; //true
  form_paypal_email_label: string; //null
  form_company_position: number; //6;
  form_company_required: boolean; //false
  form_company_checked: boolean; //false
  form_company_label: string; //null
  form_street_position: number; //7;
  form_street_required: boolean; //false
  form_street_checked: boolean; //false
  form_street_label: string; //null
  form_city_position: number; //8;
  form_city_required: boolean; //false
  form_city_checked: boolean; //false
  form_city_label: string; //null
  form_state_position: number; //9;
  form_state_required: boolean; //false
  form_state_checked: boolean; //false
  form_state_label: string; //null
  form_country_position: number; //10;
  form_country_required: boolean; //false
  form_country_checked: boolean; //false
  form_country_label: string; //null
  form_groups_position: number; //14;
  form_groups_required: boolean; //false
  form_groups_checked: boolean; //false
  form_groups_label: string; //null
  form_zip_position: number; //15;
  form_zip_required: boolean; //false
  form_zip_checked: boolean; //false
  form_zip_label: string; //null
  form_job_title_position: number; //16;
  form_job_title_required: boolean; //false
  form_job_title_checked: boolean; //false
  form_job_title_label: string; //null
  form_custom1_position: number; //11;
  form_custom1_required: boolean; //false
  form_custom1_checked: boolean; //false
  form_custom1_label: string; //null
  form_custom2_position: number; //12;
  form_custom2_required: boolean; //false
  form_custom2_checked: boolean; //false
  form_custom2_label: string; //null
  form_custom3_position: number; //13;
  form_custom3_required: boolean; //false
  form_custom3_checked: boolean; //false
  form_custom3_label: string; //null
  form_custom4_position: number; //17;
  form_custom4_required: boolean; //false
  form_custom4_checked: boolean; //false
  form_custom4_label: string; //null
  form_custom5_position: number; //18;
  form_custom5_required: boolean; //false
  form_custom5_checked: boolean; //false
  form_custom5_label: string; //null
  form_custom6_position: number; //19;
  form_custom6_required: boolean; //false
  form_custom6_checked: boolean; //false
  form_custom6_label: string; //null
  form_custom7_position: number; //20;
  form_custom7_required: boolean; //false
  form_custom7_checked: boolean; //false
  form_custom7_label: string; //null
  form_custom8_position: number; //21;
  form_custom8_required: boolean; //false
  form_custom8_checked: boolean; //false
  form_custom8_label: string; //null
  form_custom9_position: number; //22;
  form_custom9_required: boolean; //false
  form_custom9_checked: boolean; //false
  form_custom9_label: string; //null
  form_custom10_position: number; //23;
  form_custom10_required: boolean; //false
  form_custom10_checked: boolean; //false
  form_custom10_label: string; //null
  form_date_of_birth_position: number;
  form_date_of_birth_required: boolean;
  form_date_of_birth_checked: boolean;
  form_date_of_birth_label: string;
};

export type FormField = {
  fieldType: FormFieldType;
  fieldName: string;
  showFieldKey: string;
  showFieldValue?: boolean;
  fieldPositionKey: string;
  fieldPositionValue?: number;
  fieldLabelKey: string;
  fieldLabelValue?: string;
  isFieldRequiredKey: string;
  isFieldRequiredValue?: boolean;
  fieldErrorMsgKey: string;
  fieldErrorMsgValue?: string;
  isEmail?: boolean;
  isPassword?: boolean;
  isNumber?: boolean;
  validator?: Function;
  isValid?: boolean;
  hasLiveValidation?: boolean;
};

export type MetaCustomization = {
  head_title?: string; //"Ambassador Portal";
  head_description?: string; //"Spread the word about the brands you love. Get rewarded for being a brand ambassador";
  favicon?: string;
};

export type CustomizationReducerPropsType = {
  main: Customization;
  customizationStatus?: ServerStatus;
  login?: LoginCustomization;
  header?: HeaderCustomization;
  sidebar?: SideBarCustomization;
  register?: RegisterCustomization;
  meta?: MetaCustomization;
};

export enum FormFieldType {
  INPUT = 'input',
  BOOLEAN = 'checkbox',
  CHOICE = 'select',
  DATE = 'date',
  EMAIL = 'input',
}

export type PortalLoginCustomization = {
  backgroundColor: string;
  fieldsBackgroundColor: string;
  fieldsTextColor: string;
  forgotPasswordTextColor: string;
  iconsColor: string;
  loginButtonColor: string;
  loginButtonTextColor: string;
};

export type PortalTabsCustomization = {
  activity_tab_text: string;
  assets_tab_text: string;
  dashboard_tab_text: string;
  link_color: string;
  order?: string[];
  referral_network_tab_text?: string;
  rewards_tab_text: string;
  sharing_tab_text: string;
  show_activity_tab: boolean;
  show_assets_tab: boolean;
  show_dashboard: boolean;
  show_logout: boolean;
  show_profile: boolean;
  show_referral_network_tab?: boolean;
  show_rewards: boolean;
  show_sharing: boolean;
  show_stats_tab: boolean;
  stats_tab_text: string;
  theme: 'light' | 'dark';
};

export type PortalStatsCustomization = {
  show_clicks_stat: boolean;
  show_shares_stat: boolean;
  show_clicks_graph: boolean;
  show_shares_graph: boolean;
  show_referrals_stat: boolean;
  show_referrals_graph: boolean;
};

export type PortalProfileCustomization = {
  show_custom1: boolean;
  show_custom2: boolean;
  show_custom3: boolean;
  show_custom4: boolean;
  show_custom5: boolean;
  show_custom6: boolean;
  show_custom7: boolean;
  show_custom8: boolean;
  show_custom9: boolean;
  show_custom10: boolean;
  show_paypal_email: boolean;
  show_preferred_payment: boolean;
};

export type PortalActivityCustomization = {
  show_event_data1: boolean;
  show_event_data2: boolean;
  show_event_data3: boolean;
  show_referred_name: boolean;
  show_referred_email: boolean;
  show_expiration_date: boolean;
};

export type PortalRegisterCustomization = {
  background_color: string;
};

export type PortalDashboardCustomization = {
  show_raf: boolean;
  show_earned: boolean;
  show_cash_expired: boolean;
  show_cash_redeemed: boolean;
  show_points_earned: boolean;
  show_tasks_section: boolean;
  show_tier_progress: boolean;
  show_badges_section: boolean;
  show_cash_available: boolean;
  show_points_expired: boolean;
  show_paid_out_so_far: boolean;
  show_points_redeemed: boolean;
  show_awaiting_payment: boolean;
  show_points_available: boolean;
  show_awaiting_approval: boolean;
  show_tasks_description: boolean;
  points_earned_title?: string;
  points_available_title?: string;
  points_redeemed_title?: string;
  points_expired_title?: string;
  earned_title?: string;
  awaiting_approval_title?: string;
  awaiting_payment_title?: string;
  paid_out_so_far_title?: string;
  cash_available_title?: string;
  cash_redeemed_title?: string;
  cash_expired_title?: string;
  tasks_section_description: string;
  badges_section_description: string;
  show_activity_overview_section: boolean;
  show_referral_earned_first_event: boolean;
  show_referral_earned_second_event: boolean;
  show_referral_earned_first_event_text: string;
  show_referral_earned_second_event_text: string;
  show_rewards_cash_earned: boolean;
  rewards_cash_earned_title?: string;
  show_rewards_cash_fulfilled: boolean;
  rewards_cash_fulfilled_title?: string;
  show_rewards_cash_balance: boolean;
  rewards_cash_balance_title?: string;
  show_rewards_points_earned: boolean;
  rewards_points_earned_title?: string;
  show_rewards_points_fulfilled: boolean;
  rewards_points_fulfilled_title?: string;
  show_rewards_points_balance: boolean;
  rewards_points_balance_title?: string;
  show_cash_earned?: boolean;
  cash_earned_title?: string;
  show_rewards_cash_redeemed?: boolean;
  show_rewards_cash_expired?: boolean;
  show_rewards_points_redeemed?: boolean;
  show_rewards_points_expired?: boolean;
  rewards_cash_redeemed_title?: string;
  rewards_cash_expired_title?: string;
  rewards_points_redeemed_title?: string;
  rewards_points_expired_title?: string;
};

export type PortalReferralNetworkCustomization = {
  advocate_label?: string;
  description?: string;
  journey_stage_label?: string;
  orders_label?: string;
  referral_revenue_label?: string;
  referred_by_label?: string;
  referrals_label?: string;
  show_csv_export?: boolean;
  show_journey_stage?: boolean;
  show_level_toggle?: boolean;
  show_orders?: boolean;
  show_referral_revenue?: boolean;
  show_referrals?: boolean;
};

export type PortalCustomizations = {
  tabs: PortalTabsCustomization;
  login: PortalLoginCustomization;
  stats: PortalStatsCustomization;
  profile: PortalProfileCustomization;
  activity: PortalActivityCustomization;
  referral_network?: PortalReferralNetworkCustomization;
  register: PortalRegisterCustomization;
  dashboard: PortalDashboardCustomization;
  dashboard_head_scripts?: string;
  dashboard_body_scripts?: string;
  storefront: StorefrontCustomization;
};

export type StorefrontCustomization = {
  dashboard: Pick<
    PortalDashboardCustomization,
    | 'show_points_available'
    | 'points_available_title'
    | 'show_points_redeemed'
    | 'points_redeemed_title'
    | 'show_points_expired'
    | 'points_expired_title'
    | 'show_cash_available'
    | 'cash_available_title'
    | 'show_cash_redeemed'
    | 'cash_redeemed_title'
    | 'show_cash_expired'
    | 'cash_expired_title'
    | 'show_cash_earned'
    | 'cash_earned_title'
  >;
  tabs: Pick<PortalTabsCustomization, 'show_activity_tab' | 'activity_tab_text' | 'theme' | 'link_color' | 'show_logout'>;
  storefront_portal_logo: string;
  login: Pick<
    PortalLoginCustomization,
    'backgroundColor' | 'loginButtonColor' | 'loginButtonTextColor' | 'iconsColor' | 'fieldsTextColor' | 'fieldsBackgroundColor'
  > & {
    // Client-authored plain text shown on the storefront login screen.
    // camelCase to match the cross-repo contract of the rest of the `login` section.
    customCopy?: string;
  };
};

export type StorefrontLoginTheme = {
  backgroundColor: string;
  loginButtonColor: string;
  loginButtonTextColor: string;
  iconsColor: string;
  fieldsTextColor: string;
  fieldsBackgroundColor: string;
};
